/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlanChangePreview
 */
export interface PlanChangePreview {
    /**
     * Amount charged today, in cents, including tax
     * @type {number}
     * @memberof PlanChangePreview
     */
    amount_due?: number;
    /**
     * Proration credit for unused time on the current plan, in cents, as a positive magnitude
     * @type {number}
     * @memberof PlanChangePreview
     */
    credit?: number;
    /**
     * Tax portion of amount_due, in cents
     * @type {number}
     * @memberof PlanChangePreview
     */
    tax?: number;
    /**
     * Unix timestamp the proration was calculated at; pass this back when confirming the change
     * @type {number}
     * @memberof PlanChangePreview
     */
    proration_date?: number;
    /**
     * Unix timestamp the new billing period ends
     * @type {number}
     * @memberof PlanChangePreview
     */
    new_period_end?: number;
}

/**
 * Check if a given object implements the PlanChangePreview interface.
 */
export function instanceOfPlanChangePreview(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PlanChangePreviewFromJSON(json: any): PlanChangePreview {
    return PlanChangePreviewFromJSONTyped(json, false);
}

export function PlanChangePreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanChangePreview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount_due': !exists(json, 'amount_due') ? undefined : json['amount_due'],
        'credit': !exists(json, 'credit') ? undefined : json['credit'],
        'tax': !exists(json, 'tax') ? undefined : json['tax'],
        'proration_date': !exists(json, 'proration_date') ? undefined : json['proration_date'],
        'new_period_end': !exists(json, 'new_period_end') ? undefined : json['new_period_end'],
    };
}

export function PlanChangePreviewToJSON(value?: PlanChangePreview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount_due': value.amount_due,
        'credit': value.credit,
        'tax': value.tax,
        'proration_date': value.proration_date,
        'new_period_end': value.new_period_end,
    };
}

